import apiHelpers from '@/utils/api'
import { AlrContainer } from '@/models/response/AlrContainer'
import { AxiosPromise } from 'axios'
import { AloFacetteType,cleanAloFacetteType } from '@/models/alo/AloFacetteType'
import { AloFacetteFamTrad, cleanAloFacetteFamTrad } from '@/models/alo/AloFacetteFamTrad'

export default {
  getAllFacetteType(): AxiosPromise<AlrContainer<Array<AloFacetteType>>> {    
    return apiHelpers.apiCall({ 
      url: `/webapi/api/admin/FacetteType`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<Array<AloFacetteType>>
      }]
    })
  },
  
  saveFacetteFamTrad(facetteFamTrad:AloFacetteFamTrad):AxiosPromise<AlrContainer<AloFacetteFamTrad>> {
    cleanAloFacetteFamTrad(facetteFamTrad)       
    if(facetteFamTrad.id) {
      return  apiHelpers.apiCall({ 
        url: `/webapi/api/admin/FacetteTrad/${facetteFamTrad.id}`, 
        method: 'PUT',
        data: facetteFamTrad,
        transformResponse: [function (data:string) {          
          return JSON.parse(data) as AlrContainer<AloFacetteFamTrad>
        }]
      })  
    }
    else{
      return  apiHelpers.apiCall({ 
        url: `/webapi/api/admin/FacetteTrad`, 
        method: 'POST',
        data: facetteFamTrad,
        transformResponse: [function (data:string) {          
          return JSON.parse(data) as AlrContainer<AloFacetteFamTrad>
        }]
      })    
    }
  }
}
